import { Injectable, signal } from '@angular/core';

export enum NavShellState {
  open = 'open',
  close = 'close',
  hide = 'hide',
}

@Injectable({ providedIn: 'root' })
export class NavShellService {
  private _sideNavState = signal<NavShellState>(NavShellState.open);
  public readonly sideNavState = this._sideNavState.asReadonly();

  public toggle(): void {
    this._sideNavState.update((current) => (current === NavShellState.close ? NavShellState.open : NavShellState.close));
  }

  public open(): void {
    this._sideNavState.set(NavShellState.open);
  }

  public close(): void {
    this._sideNavState.set(NavShellState.close);
  }

  public hide(): void {
    this._sideNavState.set(NavShellState.hide);
  }
}
